import Cookies from "js-cookie";
import ClmGetTrackingService from "../ClmTrackingService";
import fetchUrl from "../fetchUrl";
import makeAjaxRequest from "../makeAjaxRequest";
import UserService from "../UserService";
import { detectMobile } from "../utils";
import FetchService from "../FetchService/CustomService";
import CookieService from "../CookieService";
import useRedirectionStore from "../../zustandStores/redirectionStore";
import { StorageService } from "../StorageService";
import useUserProfileStore from "../../zustandStores/userProfileStore";
import { fireFacebookPixelEvent } from "../FacebookPixelService";
import useJobOwnershipStore from "../../zustandStores/useJobOwnershipStore";
import { useJobPostingSessionStore } from "../../zustandStores/jobPostingSessionStore";
import { JPF_SESSION_INFO_KEY } from "../constants";

const BaseUrl = process.env.BASE_URL;

const LogService = {
  log(nameObject, info, status) {
    try {
      let val = info;
      if (!val) {
        val = {};
      }

      // ADD V2 SESSION TRACKING LOGIC HERE
      if (nameObject[JPF_SESSION_INFO_KEY]) {
        try {
          const sessionStore = useJobPostingSessionStore.getState();

          // Get session data from store
          const sessionData = {
            jpf_session_id: sessionStore.getSessionId(),
            job_post_flow: sessionStore.getJobPostFlow()
          };

          // MERGE session data with existing info
          // Session data has lower priority - existing info takes precedence
          val = {
            ...sessionData,  // Session data first (lower priority)
            ...val          // Existing info second (higher priority)
          };
        } catch (error) {
          // Silently continue if session store unavailable - no console.warn to avoid noise
        }
      }

      const trackingId = useRedirectionStore.getState()?.trackingId;

      let eventSource = "";
      if (window?.location?.search) {
        const params = new URLSearchParams(window.location.search);
        if (params && params.get) {
          const source = params.get("eventSource");
          if (source && val?.trackSource) {
            eventSource = source;
          }
          const m = params.get("m");
          if (m == 1) {
            val.appPurchase = true;
          }
        }
      }
      delete val.trackSource;

      // Get profile data from Zustand store
      const profileData = useUserProfileStore.getState().profileData;
      let isJobOwned = undefined;
      if (info?.job_id || info?.jobId) {
        const jobId = info?.job_id || info?.jobId;
        isJobOwned = useJobOwnershipStore.getState().isJobOwned(jobId);
      }
      val = {
        ...val, // This preserves jpf_session_id from V2 session tracking
        pageUrlSource: window?.location?.href,
        ...(profileData && {
          userType: profileData.userType,
          userCohort: profileData.userCohort,
          isJobOwned
        })
      };

      if (eventSource) {
        val.source = eventSource;
      }
      if (nameObject.category === "OWNER_EMPLOYEE_MAPPING") {
        val.flow = window.location.href?.includes("show_owner_employee_mapping")
          ? "MAILER"
          : undefined;
      }
      if (trackingId) {
        val.trackingId = trackingId;
      }
      const campaign = StorageService.getFromSessionStorage("campaign") || "";
      const campaignSource =
        StorageService.getFromSessionStorage("campaignSource") || "";

      if (campaign || campaignSource) {
        val.campaign = campaign;
        val.campaignSource = campaignSource;
      }
      ClmGetTrackingService().track({ eventName: nameObject.name, value: val });

      if (process.env.BASE_URL === "https://api.jobhai.com") {
        if (window.gtag) {
          window.gtag("event", nameObject.name, {
            device_id: Cookies.get("recDeviceId"),
            send_to: ["G-95RRWMBJ2G"]
          });
        }

        // Facebook Pixel tracking via helper
        fireFacebookPixelEvent(nameObject.name);
      }

      const env =
        process.env.LIVE_URL == "https://recruiter.jobhai.com"
          ? "production"
          : "staging";
      const token = UserService.getAccessToken();
      const isNativeApp = CookieService.getCookie("is_native_app");

      makeAjaxRequest({
        method: token ? "POST" : "POST_NO_AUTH",
        url: fetchUrl("logs", "log-events"),
        data: [
          {
            event_category: nameObject.category,
            event_type: nameObject.name,
            event_info: JSON.stringify(val),
            source: isNativeApp
              ? `app-web-view-${env}`
              : detectMobile()
                ? `mobile-website-${env}`
                : `desktop-website-${env}`,
            user_type: "recruiter",
            event_status: status ? "true" : true,
            updatedAt: new Date(),
            createdAt: new Date()
          }
        ]
      }).catch(error => {
        console.log("Error in Event log!!", error);
      });
    } catch (error) {
      console.error("[LogService] Error in log method:", error);
    }
  },

  auraLogsServices(error) {
    makeAjaxRequest({
      method: "POST_NO_AUTH",
      url: fetchUrl("logs", "aura"),
      data: error
    }).catch(error => {
      console.log("Error in Aura logs!!", error);
    });
  },

  async trackLink({ trackingId, action }) {
    const url = BaseUrl + "/logs/purchase-link-log";

    try {
      const res = await FetchService.postCall({
        url,
        body: {
          trackingId,
          action,
          deviceId: CookieService.getCookie("recDeviceId")
        },
        headers: {
          hideInterceptorMessage: "true"
        }
      });
      return res.data.data;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  updateTnc() {
    const url = BaseUrl + "/recruiter/transactions/update-tnc";
    try {
      const res = FetchService.postCall({
        url,
        body: {},
        headers: {
          hideInterceptorMessage: "true"
        }
      });
    } catch (err) {
      return Promise.reject(err);
    }
  }
};

export default LogService;
